<template lang="pug">
div
  .describe
    userListApprove(:userList="info.assigneeList" :disabled="true" v-if="info.assigneeList.length>0")
    el-button.addPeople(icon="el-icon-plus" v-else-if="info.allowAddApproverDynamic===1"  size="mini" type="primary" circle title="选择审批人" @click="openPerson")
    userItem(:userList="peopleList" :disabled="false" v-if="peopleList.length>0" @deleteUser="deleteAssUser")
    span.noUser(v-if="info.assigneeList.length==0 && peopleList.length===0") 无审批人
  choosePeople(ref="choosePeople" :usersList="peopleList"  @userSelected="userSelected" )
</template>

<script>
import userList from "@/CommonDP/components/userList/index.vue";
import choosePeople from "./choosePeople.vue";
import userItem from "./userItem.vue";
import { setNodeUserDtoList } from "./index";
import { mapState } from "vuex";
import userListApprove from "./userListApprove.vue";

export default {
  components: {
    userList, choosePeople, userItem, userListApprove
  },
  props: {
    info: {
      type: Object,
      default: () => {}
    },
    step: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      peopleList: []
    };
  },
  computed: {
    ...mapState({
      enterpriseId: state => state.enterprise.enterpriseId
    }),
    // 审批人设置 0指定成员；1申请人本身；2申请人自选；3部门主管；4申请人主管；5程序自定义；6部门标签
    assigneeSelectionStrategy() {
      return this.info.assigneeSelectionStrategy;
    },
    // 已有具体审批人处理
    defaultStrategy() {
      return !this.assigneeSelectionStrategy || this.assigneeSelectionStrategy === "0" || this.assigneeSelectionStrategy === "1";
    },
    assigneeList() {
      return this.info.assigneeList;
    },
    // 审批时才决定处理人 1:true;0:false
    runtimeSelectUsers() {
      return this.info.runtimeSelectUsers;
    },
    // 流程节点
    flowNodeDefinitionId() {
      return this.info.flowNodeDefinitionId;
    }
  },
  methods: {
    // 选择审批人
    openPerson() {
      this.$refs.choosePeople.openDialog();
    },
    userSelected(val) {
      this.peopleList = [...this.peopleList, ...val];
      const flowNodeDtoList = this.peopleList.map(e => {
        return {
          ...e,
          userName: e.name,
          type: 0
        };
      });
      setNodeUserDtoList(flowNodeDtoList, this.flowNodeDefinitionId);
    },
    // 删除
    deleteAssUser(val) {
      this.peopleList = this.peopleList.filter(e => e.userId !== val.userId);
      const flowNodeDtoList = this.peopleList.map(e => {
        return {
          ...e,
          userName: e.name,
          type: 0
        };
      });
      setNodeUserDtoList(flowNodeDtoList, this.flowNodeDefinitionId);
    },
    changeUserName(list) {
      return list.map(e => {
        return {
          ...e,
          name: e.userName
        };
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.describe{
  width: 100%;
}
.noUser{
  display: block;
  font-size: 14px;
  line-height: 35px;
}
</style>
